<div class="container-home">

  <div class="banniere-container">
    <app-banniere couleur="#3d9499"></app-banniere>
  </div>


  <div class="slider-container">
    <app-slider></app-slider>
  </div>

  <div class="cards-wrapper">
    <app-cards-doggoverse></app-cards-doggoverse>
  </div>

  <div class="map-container">
    <div>
      <app-open-map></app-open-map>
    </div>

    <div class="text-content">
      <div class="horaires" style="color: var(--color-doggoverse-jaune); font-weight: bold; padding-left: 24px; font-size: 25px">
        Nos horaires d'ouverture
      </div>

      <div class="horaires" style="color: #F1EEDA; padding-left: 24px; font-size: 25px">
        <ul>
          <li>Du Mardi au Vendredi: 10h à 13h - 15h à 19h</li>
          <li>Le Samedi: 10h à 13h - 14h à 19h</li>
          <li>Le Dimanche et Lundi: Fermé</li>
        </ul>
      </div>
    </div>


  </div>

</div>
